import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function impactTransactionReducer(
  state = initialState.impactTransactStats
    ? initialState.impactTransactStats
    : null,
  action
) {
  switch (action.type) {
    case types.TRANSACTION_IMPACT_SUCCESS:
      return action.impactTransactStats;
    case types.TRANSACTION_IMPACT_FAILED:
      return action.error;
    default:
      return state;
  }
}
